import { zodResolver } from "@mantine/form";
import { emailReminderNotificationTemplateDataSchema } from "beitary-shared";
import { z } from "zod";

const emailTemplateFormSchema = emailReminderNotificationTemplateDataSchema;

export type EmailTemplateFormValues = z.infer<typeof emailTemplateFormSchema>;

export const rules = zodResolver(emailTemplateFormSchema);
